import moment, { Moment } from 'moment';

export default (date: Moment | null | string | Date, format = 'MM/DD/YYYY HH:mm A', dateFormat?: string) => {
    if (!date || !moment(date).isValid()) return '';
    return moment(date, dateFormat).format(format);
};
